import '~/js/modules/fend';
import Cookie from '~/js/modules/Cookie';
// react form components
import CountryStateSelector from '~/js/components/form-controls/CountryStateSelector';
import CustomRecaptcha from '~/js/components/form-controls/CustomRecaptcha';

if(!Cookie.has('ALREADY_SUBSCRIBED')) {
  $('#footer-form-container').show();
}

const internals = {
  formSubmitted() {
    const $form = $('.subscribe-form');
    const $thankyouMessage = $('.thank-you-message-wrapper');

    $form.slideUp('fast');
    $thankyouMessage.slideDown('fast');
    document.cookie = 'ALREADY_SUBSCRIBED=true; Path=/; expires=Fri, 31 Dec 9999 23:59:59 GMT;';
  }
};

if (window.beaches_app.extra.countries) {
  // create new array for countries and appending a new object that represents default value
  const countries = [
    {
      name: 'Please Select',
      id: '',
      regionCode: '',
      code: ''
    },
    ...window.beaches_app.extra.countries
  ];

  // create new array for states and appending a new object that represents default value
  const states = [];

  ReactDOM.render(
    <CountryStateSelector
      countries={ countries }
      states={ states }
      countryName="country"
      stateName="state"
      stateLabelWrapper="lg-4 hide"
      stateInputWrapper="lg-8 hide"
      countryLabelWrapper="lg-4"
      countryLabel="Select Country"
      countryInputWrapper="lg-8"
      isStateRequired={false}
    />,
    document.getElementById('country-state-selector')
  );
}

ReactDOM.render(
  <CustomRecaptcha
    wrapperClassName="xs-12 lg-12"
  />,
  document.getElementById('google-recaptcha')
);

// Form Validation
$('.subscribe-form').fend({
  customBehaviorAfterSuccess: internals.formSubmitted,
  rules: {
    firstName: 'lettersOnly'
  }
});
